import inputData from './inputData/online-quote-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'online-quote-form',
  title: 'Online Quote Form',
  description: 'Let customers request a quick, accurate quote for your services in just a few simple steps.',
  image: '/images/templates/online-quote-form.png',
  tags: ['sales', 'make-sales', 'lead-generation', 'customer-success'],
  inputData: inputData,
  popular: true,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

